module.exports = __webpack_public_path__ + "static/media/bg_9_and_10_front.2f40e7ff.png";